module.exports = __webpack_public_path__ + "static/desktop/img/calendar-3.5a2e8507.png";